<template>
  <Modal
    :id="id"
    :modalTitle="modalTitle"
    :classes="classes"
    :showFooter="showFooter"
  >
    <p>{{ message }}</p>
    <button
      class="btn btn-primary generalPrimaryButton float-right"
      data-dismiss="modal"
    >
      Cerrar
    </button>
  </Modal>
</template>

<script>
import Modal from "../Shared/Modal.vue"

export default {
  name: "ModalFinal",
  props: {
    id: Number,
    modalTitle: String,
    class: String,
    showFooter: Boolean,
    message: {
      type: String,
      default: () => "La informacion se enviado correctamente"
    }
  },
  components: {
    Modal
  },
  data() {
    return {
      classes: this.class
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"></style>
